/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

const styles = (/* theme */) => ({
	toolIconDark: {
		color: 'black',
	},
	card: {
		width: 'inherit',
		height: 'inherit',
		maxWidth: 500,
	},
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/base/listing/styles.js